var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theme-dark"},[_c('div',{staticClass:"navbar",class:[_vm.isLeftPadded]},[_vm._t("logo"),_c('div',{staticClass:"navbar-middle"},[_vm._t("middle")],2),_c('div',{staticClass:"navbar-actions"},[_vm._t("actions")],2)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }